import {HttpRequest} from '@services/HttpClient';
import {APIInterface} from '@services/services.type';
import {trackErrorEvents} from '@utils/googleAnalytics/googleAnalyticsEvents';
import {getAPIUrl} from '@utils/service.utils';

export type requestLeadGenerationR = any;

// this function is to request for lead generation for launches and teaser
export function requestLeadGenerationAPI(
  payload: Record<string, any>
): APIInterface<undefined, requestLeadGenerationR> {
  const options = {
    method: 'POST' as const,
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(payload),
  };
  const route = `search/feature/new-launches-lead`;
  const httpRequest = new HttpRequest(getAPIUrl('search', route), options);
  return {
    getResponse: async () => {
      try {
        const response = await httpRequest.send();
        return response;
      } catch (err: any) {
        trackErrorEvents({
          type: 'request_lead_generation_failed',
          errorStack: err,
        });
        throw err;
      }
    },
    abort: httpRequest.abort,
  };
}
